const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '传媒在线观看',
  url: 'https://www.chuanmeizaixian.com',
  description: '传媒在线观看，汇聚海量高清视频资源，支持直播、点播、回看全场景体验。覆盖新闻、综艺、纪录片、影视剧等全品类内容。',
  logo: 'https://www.chuanmeizaixian.com/logo.png',
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '+86-400-888-0000',
    contactType: 'customer service',
    availableLanguage: ['Chinese'],
  },
  sameAs: [
    'https://weibo.com/chuanmeizaixian',
    'https://www.zhihu.com/org/chuanmeizaixian',
  ],
};

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '传媒在线观看',
  url: 'https://www.chuanmeizaixian.com',
  description: '传媒在线观看，汇聚海量高清视频资源，支持直播、点播、回看全场景体验。',
  inLanguage: 'zh-CN',
};

export function getWebPageSchema(url: string, name: string, description: string, datePublished?: string) {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name,
    url,
    description,
    ...(datePublished ? { datePublished } : {}),
    isPartOf: {
      '@type': 'WebSite',
      name: '传媒在线观看',
      url: 'https://www.chuanmeizaixian.com',
    },
  };
}

export function getBreadcrumbSchema(items: Array<{ name: string; url: string }>) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: item.url,
    })),
  };
}

export function getArticleSchema(
  title: string,
  description: string,
  url: string,
  datePublished: string,
  author: string,
  image: string
) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: title,
    description,
    url,
    datePublished,
    dateModified: datePublished,
    author: {
      '@type': 'Person',
      name: author,
    },
    image,
    publisher: {
      '@type': 'Organization',
      name: '传媒在线观看',
      logo: {
        '@type': 'ImageObject',
        url: 'https://www.chuanmeizaixian.com/logo.png',
      },
    },
  };
}

export function getFAQSchema(questions: Array<{ question: string; answer: string }>) {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: questions.map((q) => ({
      '@type': 'Question',
      name: q.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: q.answer,
      },
    })),
  };
}

export { organizationSchema, websiteSchema };